// extracted by mini-css-extract-plugin
module.exports = {"modifyNameWrapper":"style_modifyNameWrapper__c_W4o","saveBtn":"style_saveBtn__2ZAkK"};